.checkboxContainer {
  display: flex;
  gap: var(--ism-spacing-xs);
  align-items: center;
  padding-top: var(--ism-spacing-xs);
  padding-bottom: var(--ism-spacing-xs);
  margin-bottom: 0;
  color: var(--ism-color-on-surface-variant);
  cursor: pointer;
}

.checkboxContainer[data-hovered],
.checkboxContainer[data-focused] {
  color: var(--ism-color-on-surface);
}

.checkboxContainer[data-disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.checkboxIcon {
  display: grid;
  place-content: center;
  width: 18px;
  height: 18px;
  margin-inline-start: 2px;
  border: 1px solid var(--ism-color-on-surface-variant);
  border-radius: var(--ism-spacing-2xs);
}

.checkboxIcon::before {
  display: block;
  width: 13px;
  height: 10px;
  content: "";
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 10' fill='none'%3E%3Cpath d='M4.35651 8.22217L11.5553 1.02342C11.6791 0.899395 11.8241 0.836062 11.9903 0.833423C12.1564 0.830784 12.3041 0.894117 12.4334 1.02342C12.5627 1.15273 12.6273 1.3012 12.6273 1.46884C12.6273 1.63662 12.5627 1.78516 12.4334 1.91446L4.8838 9.47696C4.73311 9.62752 4.55734 9.7028 4.35651 9.7028C4.15568 9.7028 3.97991 9.62752 3.82922 9.47696L0.350054 5.9978C0.226165 5.87377 0.165054 5.72655 0.16672 5.55613C0.168248 5.38585 0.233665 5.23606 0.36297 5.10675C0.492276 4.97745 0.640748 4.9128 0.808387 4.9128C0.976165 4.9128 1.12471 4.97745 1.25401 5.10675L4.35651 8.22217Z' fill='%23fff'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 10' fill='none'%3E%3Cpath d='M4.35651 8.22217L11.5553 1.02342C11.6791 0.899395 11.8241 0.836062 11.9903 0.833423C12.1564 0.830784 12.3041 0.894117 12.4334 1.02342C12.5627 1.15273 12.6273 1.3012 12.6273 1.46884C12.6273 1.63662 12.5627 1.78516 12.4334 1.91446L4.8838 9.47696C4.73311 9.62752 4.55734 9.7028 4.35651 9.7028C4.15568 9.7028 3.97991 9.62752 3.82922 9.47696L0.350054 5.9978C0.226165 5.87377 0.165054 5.72655 0.16672 5.55613C0.168248 5.38585 0.233665 5.23606 0.36297 5.10675C0.492276 4.97745 0.640748 4.9128 0.808387 4.9128C0.976165 4.9128 1.12471 4.97745 1.25401 5.10675L4.35651 8.22217Z' fill='%23fff'/%3E%3C/svg%3E");
  transition: 120ms transform ease-in-out;
  transform: scale(0);
  transform-origin: bottom left;
}

.checkboxContainer[data-hovered] .checkboxIcon {
  background-color: color-mix(
    in srgb,
    var(--ism-color-on-primary),
    var(--ism-color-primary) 5%
  );
  border-color: var(--ism-color-on-surface);
  outline: 2px solid
    color-mix(in srgb, var(--ism-color-on-primary), var(--ism-color-primary) 5%);
}

.checkboxContainer[data-focused] .checkboxIcon {
  border-color: var(--ism-color-on-surface);
  outline: 2px solid var(--ism-color-focused);
}

.checkboxContainer[data-selected] .checkboxIcon {
  background-color: var(--ism-color-on-surface);
  border-color: var(--ism-color-on-surface);
}

.checkboxContainer[data-selected] .checkboxIcon::before {
  background-color: var(--ism-color-on-primary);
  border-color: var(--ism-color-on-surface-variant);
  transform: scale(1);
}

.checkboxContainer[data-invalid] .checkboxIcon {
  background-color: var(--ism-color-error-container);
  border-color: var(--ism-color-error);
}

.checkboxContainer[data-selected][data-invalid] .checkboxIcon {
  background-color: var(--ism-color-on-surface);
  border-color: var(--ism-color-error);
}

.checkboxContainer[data-indeterminate] .checkboxIcon::before {
  width: 14px;
  height: 2px;
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2' fill='none'%3E%3Cpath d='M13.25 0.375H0.75V1.625H13.25V0.375Z' fill='%23fff'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2' fill='none'%3E%3Cpath d='M13.25 0.375H0.75V1.625H13.25V0.375Z' fill='%23fff'/%3E%3C/svg%3E");
  transform: scale(0);
}

.checkboxContainer[data-selected][data-indeterminate] .checkboxIcon::before {
  width: 14px;
  height: 2px;
  background-color: var(--ism-color-on-primary);
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2' fill='none'%3E%3Cpath d='M13.25 0.375H0.75V1.625H13.25V0.375Z' fill='%23fff'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2' fill='none'%3E%3Cpath d='M13.25 0.375H0.75V1.625H13.25V0.375Z' fill='%23fff'/%3E%3C/svg%3E");
  transform: scale(1);
}
